module.exports = __webpack_public_path__ + "img/漂浮元素2@2x.a4f9c952.png";